module.exports = __webpack_public_path__ + "media/src/images/page01_t_workbook01-ad15e1719b27181297840452c1c2a5fe.png";